module.exports = __webpack_public_path__ + "static/media/ibd_shoulder3.fde1f359.png";